@if (!isCallToActionButton) {
<h-icon-button
    [name]="'product-item-add-to-cart'"
    [id]="'product-item-add-to-cart-' + id"
    [border]="!isLoading"
    [backgroundColor]="isLoading ? 'secondary-dark' : 'secondary'"
    [iconSize]="'10px'"
    [lineHeight]="'normal'"
    [buttonSize]="'small'"
    [describedBy]="describedBy"
    [isLoading]="isLoading"
    (click)="quickBuyAction($event)"
    (keydown.enter)="quickBuyAction($event)"
    (mouseup)="stopEventPropagation($event)">
    <h-svg-icon [name]="'cart'"></h-svg-icon>
    <span i18n="@@hermes-global-translations.buy" hSrOnlyNoSnippet text>Add to cart</span>
</h-icon-button>
} @else {
<h-call-to-action
    [name]="'product-item-add-to-cart'"
    [id]="'product-item-add-to-cart-' + id"
    [appearance]="'primary'"
    [size]="'medium'"
    (click)="quickBuyAction($event)"
    (keydown.enter)="quickBuyAction($event)"
    (mouseup)="stopEventPropagation($event)"
    i18n="@@hermes_commerce.add-to-cart">
    Add to cart
</h-call-to-action>
}
